import { gql } from '@apollo/client'

const UPDATE_COURSE_TYPE_IMAGE_DETAILS_MUTATION = gql`
  mutation updateCourseTypeImageDetails(
    $id: ID!
    $data: CourseTypeImageDetailsInput!
  ) {
    updateCourseTypeImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
    }
  }
`

export default UPDATE_COURSE_TYPE_IMAGE_DETAILS_MUTATION
